import { Button, Form, InputFieldRhf, XStack, Error } from '@my/ui'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import * as z from 'zod'
import { zodEmailValidator } from 'app/utils/zod-email-validator'

const formSchema = z.object({
  email: z.string().refine(zodEmailValidator, { message: 'Invalid email' }),
})

export type ForgotPasswordFormValues = z.infer<typeof formSchema>

export interface ForgotPasswordFormProps {
  loading: boolean
  error?: string
  onSubmit: (values: ForgotPasswordFormValues) => void
}

export const ForgotPasswordForm = (props: ForgotPasswordFormProps) => {
  const { control, handleSubmit } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: '',
    },
  })

  return (
    <Form
      gap="$3"
      w="100%"
      onSubmit={handleSubmit((data) => {
        props.onSubmit(data)
      })}
    >
      <InputFieldRhf
        name="email"
        control={control}
        label="Email"
        placeholder="Your email"
        inputMode="email"
        hideLabel
        required
      />

      {props.error && <Error error={props.error} />}

      <XStack gap="$3">
        <Form.Trigger asChild fd="row" ai="center">
          <Button w="100%" theme="primary" borderWidth="$0" fontSize="$5" loading={props.loading}>
            Submit
          </Button>
        </Form.Trigger>
      </XStack>
    </Form>
  )
}
